import { round } from 'lodash';

export const toUiFormat = (v) => (v ? round(v * 100, 2) : v);

export const toApiFormat = (v) => (v ? round(v / 100, 4) : v);
